import { splitNames, getWs, fromRe } from '../lib'

const getPrivateName = (name) => {
  const s = `$${name}`
  return s
}

const replaceRequire = (fromSeg, quotes, src) => {
  const eq = fromSeg.replace(/(\s+)from(\s+)([\s\S])*/, (m, b, a) => {
    return `${b}=${a}`
  })
  const req = 'r'+`equire(${quotes}${src}${quotes});`
  const res = `${eq}${req}`
  return res
}

const getVarName = (n) => {
  return n
    .replace(/[-/]/g, '_')
    .replace(/[^\w\d-]/g, '')
}

/* export { abc, def } from 'example' */
const exportRe = /^( *export\s+{([^}]+?)})/
const advancedRe = new RegExp(
  `${exportRe.source}${fromRe.source}`, 'gm'
)
// const re = new RegExp(
//   `${exportRe.source}${simpleFromRe.source}`, 'gm'
// )

/** @this {_alamode.ÀLaMode} */
function getRes(exportSeg, src, fromSeg, quotes, names) {
  const ws = this.noSourceMaps ? '' : getWs(exportSeg)
  const varName = getVarName(src)
  const privateName = getPrivateName(varName)
  const req = replaceRequire(fromSeg, quotes, src)
  const s = `${ws}const ${privateName}${req}`
  const n = splitNames(names)
  const allNames = n.reduce((acc, nn) => {
    const [name, alias] = nn.split(/\s+as\s+/)
    const nt = name.trim()
    const at = alias ? alias.trim() : null
    const fromPrivate = nt == 'default' ? privateName : `${privateName}.${nt}`
    acc[at || nt] = fromPrivate
    return acc
  }, {})
  this.emit('export', allNames)
  return s
}

/**
 * @type {_restream.Rule}
 */
const fromRule = {
  re: advancedRe,
  replacement,
}

/**
 * @suppress {globalThis}
 * @type {_alamode.ÀLaModeReplacer}
 */
function replacement(match, exportSeg, names, fromSeg, sd, ld) {
  const realSrc = ld
    ? this.markers.literals.map[ld]
    : this.markers.strings.map[sd]
  const [, quotes, src] = /** @type {!RegExpResult} */ (
    /(["'`])(.+?)\1/.exec(realSrc)
  )
  const res = getRes.call(this, exportSeg, src, fromSeg, quotes, names)
  return res
}

// const fromRule = {
//   re,
//   replacement(match, exportSeg, names, fromSeg, quotes, src) {
//     const res = getRes.call(this, exportSeg, src, fromSeg, quotes, names)
//     return res
//   },
// }

export default fromRule

/**
 * @suppress {nonStandardJsDocs}
 * @typedef {import('restream').Rule} _restream.Rule
 */
/**
 * @suppress {nonStandardJsDocs}
 * @typedef {import('alamode/types').ÀLaModeReplacer} _alamode.ÀLaModeReplacer
 */
/**
 * @suppress {nonStandardJsDocs}
 * @typedef {import('alamode/types').ÀLaMode} _alamode.ÀLaMode
 */